/* ODDDT // orbitaldrop.store — theme behaviour
   Cart drawer, quantity steppers, swatch/thumb selection, footer telemetry clock.
   Vanilla, no dependencies. Safe to run on every page. */
(function(){
  'use strict';

  function openDrawer(){ var d=document.querySelector('[data-cart-drawer]'),o=document.querySelector('[data-cart-overlay]'); if(d)d.classList.add('is-open'); if(o)o.classList.add('is-open'); }
  function closeDrawer(){ var d=document.querySelector('[data-cart-drawer]'),o=document.querySelector('[data-cart-overlay]'); if(d)d.classList.remove('is-open'); if(o)o.classList.remove('is-open'); }

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-cart-open]'); if(t){ e.preventDefault(); openDrawer(); return; }
    if(e.target.closest('[data-cart-close]')||e.target.matches('[data-cart-overlay]')){ closeDrawer(); return; }
    // quantity steppers
    var step=e.target.closest('[data-qty]');
    if(step){ var input=step.parentElement.querySelector('input'); if(input){ var v=parseInt(input.value||'1',10); v+= (step.getAttribute('data-qty')==='up'?1:-1); if(v<1)v=1; input.value=v; } return; }
    // swatches (visual select)
    var sw=e.target.closest('.od-swatch:not(.is-disabled)');
    if(sw){ sw.parentElement.querySelectorAll('.od-swatch').forEach(function(s){s.classList.remove('is-active');}); sw.classList.add('is-active'); return; }
    // gallery thumbs
    var th=e.target.closest('[data-thumb]');
    if(th){ var main=document.querySelector('[data-pdp-main] img'), src=th.querySelector('img'); if(main&&src) main.src=src.src; return; }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });

  // footer telemetry clock
  function tick(){
    var els=document.querySelectorAll('[data-utc]'); if(!els.length) return;
    var d=new Date(), p=function(n){return String(n).padStart(2,'0');};
    var s=p(d.getUTCHours())+':'+p(d.getUTCMinutes())+':'+p(d.getUTCSeconds())+' UTC';
    els.forEach(function(e){ e.textContent=s; });
  }
  tick(); setInterval(tick,1000);

  // ---- product variant resolution (swatch -> variant id + price) ----
  function resolveVariant(form){
    var json=form.querySelector('[data-variant-json]'); if(!json) return;
    var variants; try{ variants=JSON.parse(json.textContent); }catch(_){ return; }
    var groups=form.querySelectorAll('.od-swatches[data-option-index]');
    var selected=[];
    groups.forEach(function(g){ var a=g.querySelector('.od-swatch.is-active'); selected[parseInt(g.getAttribute('data-option-index'),10)]=a?a.getAttribute('data-value'):null; });
    var match=variants.filter(function(v){ return selected.every(function(val,i){ return val==null || v.options[i]===val; }); })[0];
    var idEl=form.querySelector('[data-variant-id]'), priceEl=form.querySelector('[data-price]'), addBtn=form.querySelector('[data-add]');
    if(match){
      if(idEl) idEl.value=match.id;
      if(priceEl) priceEl.textContent='$'+(match.price/100).toFixed(2);
      if(addBtn){ if(match.available){ addBtn.disabled=false; addBtn.textContent='ADD TO BAG \u25B8'; } else { addBtn.disabled=true; addBtn.textContent='SOLD OUT'; } }
    }
  }
  document.addEventListener('click',function(e){
    var sw=e.target.closest('[data-product-form] .od-swatch:not(.is-disabled)');
    if(sw){ resolveVariant(sw.closest('[data-product-form]')); }
  });
  document.addEventListener('DOMContentLoaded',function(){ document.querySelectorAll('[data-product-form]').forEach(resolveVariant); });

  /* =========================================================
     AJAX CART — add / change / remove without page reload.
     Progressive enhancement over the server-rendered drawer.
     ========================================================= */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var URL_CART = ROOT + 'cart.js';
  var URL_ADD = ROOT + 'cart/add.js';
  var URL_CHANGE = ROOT + 'cart/change.js';

  function money(cents, cur){
    try { return new Intl.NumberFormat(undefined, { style:'currency', currency: cur || 'USD' }).format(cents/100); }
    catch(e){ return '$' + (cents/100).toFixed(2); }
  }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  function lineItemHTML(it, cur){
    var img = it.image ? '<img src="'+it.image+'" alt="">' : '<div class="od-ph"></div>';
    var hasVar = it.variant_title && it.variant_title !== 'Default Title';
    var meta = hasVar ? esc(it.variant_title) + ' · ' : '';
    return '<div class="od-line-item" data-key="'+it.key+'">'
      + '<div class="thumb">'+img+'</div>'
      + '<div style="flex:1;display:flex;flex-direction:column;">'
        + '<div class="li-name">'+esc(it.product_title)+'</div>'
        + '<div class="li-meta">'+meta+'QTY '+it.quantity+'</div>'
        + '<div style="display:flex;align-items:center;gap:10px;margin-top:8px;">'
          + '<div class="od-qty od-qty--sm">'
            + '<button type="button" data-cart-qty="down" data-key="'+it.key+'" aria-label="Decrease">&#8722;</button>'
            + '<span data-qty-val>'+it.quantity+'</span>'
            + '<button type="button" data-cart-qty="up" data-key="'+it.key+'" aria-label="Increase">&#65291;</button>'
          + '</div>'
        + '</div>'
        + '<div class="li-price">'+money(it.final_line_price, cur)+'</div>'
      + '</div>'
      + '<button class="od-icon-btn" type="button" data-cart-remove data-key="'+it.key+'" aria-label="Remove">&#10005;</button>'
    + '</div>';
  }

  function renderCart(cart){
    document.querySelectorAll('.od-cart-count').forEach(function(e){ e.textContent='('+cart.item_count+')'; });
    var head=document.querySelector('[data-cart-drawer-count]'); if(head) head.textContent=cart.item_count;
    document.querySelectorAll('[data-cart-units]').forEach(function(e){ e.textContent=cart.item_count; });
    var sub=document.querySelector('[data-cart-subtotal]'); if(sub) sub.textContent=money(cart.total_price, cart.currency);
    var body=document.querySelector('[data-cart-items]');
    if(body){
      body.innerHTML = cart.item_count > 0
        ? cart.items.map(function(it){ return lineItemHTML(it, cart.currency); }).join('')
        : '<p class="od-sec-sub" style="padding:40px 0;text-align:center;">BAG EMPTY · NO UNITS REGISTERED</p>';
    }
    var co=document.querySelector('[data-checkout-btn]'); if(co){ co.disabled = cart.item_count===0; }
  }

  function getCart(open){
    return fetch(URL_CART, { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ renderCart(c); if(open) openDrawer(); return c; })
      .catch(function(){ /* not on a Shopify storefront (e.g. static preview) */ });
  }
  function changeLine(key, qty){
    return fetch(URL_CHANGE, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ id:key, quantity:qty }) })
      .then(function(r){ return r.json(); })
      .then(renderCart);
  }

  // add-to-cart (intercept product forms)
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action$="/cart/add"]');
    if(!form || !form.querySelector('[name="id"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[name="add"]'); var orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled=true; btn.textContent='ADDING…'; }
    fetch(URL_ADD, { method:'POST', headers:{ 'Accept':'application/json' }, body: new FormData(form) })
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ return getCart(true); })
      .then(function(){ if(btn){ btn.disabled=false; btn.textContent=orig || 'ADD TO BAG \u25B8'; } })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=orig; } form.submit(); });
  });

  // drawer remove / quantity
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-cart-remove]');
    if(rm){ e.preventDefault(); changeLine(rm.getAttribute('data-key'), 0); return; }
    var q = e.target.closest('[data-cart-qty]');
    if(q){
      var key=q.getAttribute('data-key');
      var span=q.parentElement.querySelector('[data-qty-val]');
      var cur=parseInt(span?span.textContent:'1',10)||1;
      var next=cur + (q.getAttribute('data-cart-qty')==='up'?1:-1);
      if(next<0) next=0;
      changeLine(key, next); return;
    }
  });

  // sync drawer with live cart on load (covers back-button / cached pages)
  document.addEventListener('DOMContentLoaded', function(){ if(document.querySelector('[data-cart-items]')) getCart(false); });

  /* ---- mobile nav toggle ---- */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if(t && nav){
      var open = nav.classList.toggle('is-open');
      t.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if(nav && nav.classList.contains('is-open') && e.target.closest('[data-mobile-nav] a')){
      nav.classList.remove('is-open');
      var btn = document.querySelector('[data-nav-toggle]');
      if(btn){ btn.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); }
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var nav = document.querySelector('[data-mobile-nav].is-open');
    if(nav){ nav.classList.remove('is-open'); var btn=document.querySelector('[data-nav-toggle]'); if(btn){ btn.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); } }
  });
})();
